const playbackNotFound = new Set<string>();
const playbackNotFoundListeners = new Set<(launchId: string) => void>();

export const markRecordingPlaybackNotFound = (launchId: string): void => {
  playbackNotFound.add(launchId);
  playbackNotFoundListeners.forEach((fn) => fn(launchId));
};

export const getRecordingPlaybackNotFoundLaunchIds = (): string[] =>
  Array.from(playbackNotFound);

export const subscribeRecordingPlaybackNotFound = (
  listener: (launchId: string) => void
): (() => void) => {
  playbackNotFoundListeners.add(listener);

  return () => {
    playbackNotFoundListeners.delete(listener);
  };
};
